import styled from 'styled-components'

export const Style = styled.div`
  margin-bottom: 55px;
  margin-top: 55px;
  display: block;
  width: 100%;
  .card-vendor {
    margin-bottom: 20px;
  }
  .image {
    padding-top: 60px;
    > img {
      width: 100%;
      display: block;
    }
  }
  .column-top {
    margin-top: 40px;
  }
  .bottom-margin {
    margin-bottom: 20px;
  }
  .bottom-margin-column {
    margin-bottom: 15px;
  }
  @media screen and (min-width: 300px) and (max-width: 768px) {
    margin-bottom: 50px;
    margin-top: 50px;
    .card-vendor {
      border: solid 2px #dddddd;
      border-radius: 20px;
      justify-content: unset;
      padding: 24px 16px;
      height: 100%;
      .image {
        padding: 0;
        display: flex;
        width: 80px;
        height: 80px;
        justify-content: center;
        align-items: center;
      }
      .title {
        margin-top: 0;
        font-size: 18px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #555555;
      }
    }
  }
`
